export default __webpack_public_path__ + "static/media/shared_box_icon.d328b17d.svg";